import { z } from "zod";

export const TIME_FRAMES = ["7d", "30d", "3m", "6m", "quarter", "year", "allTime"] as const;
export const TimeFrameSchema = z.enum(TIME_FRAMES);
export type TimeFrame = z.infer<typeof TimeFrameSchema>;

export const DEFAULT_TIME_FRAME: TimeFrame = "30d";

export const DATA_FLOOR = "2025-07-15T00:00:00.000Z";
